// extracted by css-extract-rspack-plugin
export default {"footer":"dBL6R"};